const RANKING_COMPUTATION_KEYS: Record<string, string> = {
  ranking_mean_rank: "studyReport.analyst.computationRankingMeanRank",
  ranking_weighted_series: "studyReport.analyst.computationRankingWeightedSeries",
}

interface TranslateFn {
  (key: string): string
}

export function formatAnalystComputation(
  computation: string,
  t: TranslateFn,
): string {
  const key = RANKING_COMPUTATION_KEYS[computation]
  if (key) {
    return t(key)
  }
  return computation
}
